import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "StackedScrolling"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M23.25 11.25H21.75V2.25H12.75V0.75H21.75C22.5784 0.75 23.25 1.42157 23.25 2.25V11.25ZM18 16.5H19.5V6C19.5 5.17157 18.8284 4.5 18 4.5H7.5V6H18V16.5ZM3 22.5H13.5C14.3284 22.5 15 21.8284 15 21V10.5C15 9.67157 14.3284 9 13.5 9H3C2.17157 9 1.5 9.67157 1.5 10.5V21C1.5 21.8284 2.17157 22.5 3 22.5ZM3 21V10.5H13.5V21H3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/StackedScrolling.vue"]]);
